module.exports = require("@swa-ui/dotcom/src/placements/SpecialOffersPlacement/SpecialOffersCard/SpecialOffersCard.module.scss");